var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { ColumnBaseComponent } from '../base/columnbase.component';
import { ColumnService } from '../column/column.service';
import { ColumnBaseService } from '../base/columnbase.service';
var MonthComponent = /** @class */ (function (_super) {
    __extends(MonthComponent, _super);
    function MonthComponent(service, baseService) {
        var _this = _super.call(this, service, baseService) || this;
        _this.service = service;
        _this.baseService = baseService;
        _this.defOptions = {};
        return _this;
    }
    MonthComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    MonthComponent.prototype.ngOnChanges = function (changes) {
        _super.prototype.ngOnChanges.call(this, changes);
        if (changes.msg) {
            this.setDefOptions();
            if (!changes.msg.firstChange) {
                $(this.element).MonthPicker('Destroy');
                this.setMonthPicker();
            }
        }
    };
    MonthComponent.prototype.setDefOptions = function () {
        this.options = (this.col.params && this.col.params.options ? this.col.params.options : {});
        this.defOptions = {
            Button: false,
            MonthFormat: this.msg['au.COMPONENT.MonthComponent.option.format'] || 'yy/mm',
            i18n: {
                year: this.msg['au.COMPONENT.MonthComponent.label.year'] || 'Year',
                prevYear: this.msg['au.COMPONENT.MonthComponent.label.prevYear'] || 'Previous Year',
                nextYear: this.msg['au.COMPONENT.MonthComponent.label.nextYear'] || 'Next Year',
                next12Years: this.msg['au.COMPONENT.MonthComponent.label.next12Years'] || 'Jump Forward 12 Years',
                prev12Years: this.msg['au.COMPONENT.MonthComponent.label.prev12Years'] || 'Jump Back 12 Years',
                jumpYears: this.msg['au.COMPONENT.MonthComponent.label.jumpYears'] || 'Jump Years',
                backTo: this.msg['au.COMPONENT.MonthComponent.label.backTo'] || 'Back to',
                months: [
                    this.msg['au.COMPONENT.MonthComponent.label.january'] || 'Jan.',
                    this.msg['au.COMPONENT.MonthComponent.label.february'] || 'Feb.',
                    this.msg['au.COMPONENT.MonthComponent.label.march'] || 'Mar.',
                    this.msg['au.COMPONENT.MonthComponent.label.april'] || 'Apr.',
                    this.msg['au.COMPONENT.MonthComponent.label.may'] || 'May',
                    this.msg['au.COMPONENT.MonthComponent.label.june'] || 'June',
                    this.msg['au.COMPONENT.MonthComponent.label.july'] || 'July',
                    this.msg['au.COMPONENT.MonthComponent.label.august'] || 'Aug.',
                    this.msg['au.COMPONENT.MonthComponent.label.september'] || 'Sep.',
                    this.msg['au.COMPONENT.MonthComponent.label.october'] || 'Oct.',
                    this.msg['au.COMPONENT.MonthComponent.label.november'] || 'Nov.',
                    this.msg['au.COMPONENT.MonthComponent.label.december'] || 'Dec.'
                ]
            }
        };
        this.defOptions = Object.assign({}, this.defOptions, this.options);
    };
    MonthComponent.prototype.ngAfterViewInit = function () {
        this.element = this.monthElement.nativeElement;
        this.setMonthPicker();
    };
    MonthComponent.prototype.setMonthPicker = function () {
        var self = this;
        var range = (this.col.params && this.col.params.range ? this.col.params.range : {});
        var from = range.from;
        var to = range.to;
        if (from && to) {
            from = this.baseService.getColKey(this.componentName, from, this.index);
            to = this.baseService.getColKey(this.componentName, to, this.index);
            // 開始年月
            if (this.colKey === from) {
                $(this.element).MonthPicker(Object.assign({}, this.defOptions, {
                    OnBeforeMenuOpen: function (event) {
                        var val = $('input[name="' + to + '"]').val() ? $('input[name="' + to + '"]').val() : null;
                        $(this).MonthPicker('option', 'MaxMonth', val);
                    },
                    OnAfterChooseMonth: function (selectedDate) {
                        self.onChange($(this).val());
                    }
                }));
            }
            // 終了年月
            if (this.colKey === to) {
                $(this.element).MonthPicker(Object.assign({}, this.defOptions, {
                    OnBeforeMenuOpen: function (event) {
                        var val = $('input[name="' + from + '"]').val() ? $('input[name="' + from + '"]').val() : null;
                        $(this).MonthPicker('option', 'MinMonth', val);
                    },
                    OnAfterChooseMonth: function (selectedDate) {
                        self.onChange($(this).val());
                    }
                }));
            }
        }
        else {
            $(this.element).MonthPicker(Object.assign({}, this.defOptions, {
                OnAfterChooseMonth: function (selectedDate) {
                    self.onChange($(this).val());
                }
            }));
        }
    };
    MonthComponent.prototype.onChange = function (e) {
        _super.prototype.onChange.call(this, e);
    };
    MonthComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        $(this.element).MonthPicker('Destroy');
    };
    MonthComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'column-month',
                    template: '<input type="text" name="{{ colKey }}" attr.name="{{ colKey }}" [placeholder]="col" [(ngModel)]="val" (change)="onChange(val)"  [key]="key" [col]="col" columnDir #month>',
                    changeDetection: ChangeDetectionStrategy.OnPush
                }] }
    ];
    /** @nocollapse */
    MonthComponent.ctorParameters = function () { return [
        { type: ColumnService },
        { type: ColumnBaseService }
    ]; };
    MonthComponent.propDecorators = {
        monthElement: [{ type: ViewChild, args: ['month',] }]
    };
    return MonthComponent;
}(ColumnBaseComponent));
export { MonthComponent };
//# sourceMappingURL=month.component.js.map